import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { SendPostRequest } from "../../http";
import { Link } from "react-router-dom";
import createSlug from "../../utils/CreateSlug";
import Spinner from "../Spinner";

function OverlayRevealHomeSpecialist() {
  const [doctorsData, setDoctorsData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    getDoctorsData();
  }, []);

  const getDoctorsData = async () => {
    try {
      const response = await SendPostRequest("doctors/list");
      setDoctorsData(response?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching doctors data:", error);
      setLoading(false);
    }
  };

  const owlOptions = {
    // loop: true,
      loop: doctorsData.length > 4,
    nav: false,
    dots: false,
    autoplay: true,
     autoplayTimeout: 2500,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 4 },
    },
  };

  return (
    <>
      {loading ? (
        <div
          style={{ marginBottom: "100px" }}
          className="d-flex align-items-center justify-content-center"
        >
          <Spinner />
        </div>
      ) : doctorsData?.length > 0 ? (
        <section 
          id="section-team" 
          className="section-team pt-5 pb-3 o-visible semi-dark"
        >
          <div className="container">
            <div className="row">
              <div className="offset-md-3 col-md-6">
                <div className="title-wrap text-center relative">
                  <div className="section-title">
                    <h2 className="section-title text-uppercase margin-bottom-40">
                    Meet Our <span className="theme-color">Specialists</span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>
                </div>
              </div>
              <OwlCarousel
                className="owl-carousel team-main-wrapper"
                {...owlOptions}
              >
                {doctorsData?.map((data, index) => (
                  <div className="item animated fadeInDown visible" key={index}>
                    <div className="team-style-3">
                      <div className="team-inner mb-0 relative">
                        <div className="team-thumb mb-0 relative">
                          <div
                            className="img-fluid thumb w-100"
                            style={{
                              height: "270px",
                              width: "100%",
                              maxWidth: "100%",
                              backgroundImage: `url(${data?.profile})`,
                              backgroundSize: "cover",
                              backgroundPosition: "top center",
                              backgroundRepeat: "no-repeat",
                            }}
                          />
                          <div className="team-overlay">
                            {/* <div className="team-social social-icons">
                              <a href="#">
                                <span className="ti-facebook"></span>
                              </a>
                              <a href="#">
                                <span className="ti-twitter"></span>
                              </a>
                              <a href="#">
                                <span className="ti-instagram"></span>
                              </a>
                              <a href="#">
                                <span className="ti-linkedin"></span>
                              </a>
                            </div> */}
                          </div>
                        </div>
                        <div className="team-details d-flex justify-content-center flex-column align-items-center">
                          <div className="team-name">
                            <h4 className="mb-0" style={{fontSize:"22px"}}>
                              <Link
                                to={`/doctor/${data?.uid}/${createSlug(
                                  data?.full_name
                                )}`}
                                className="client-name"
                              >
                                {data?.full_name}
                              </Link>
                            </h4>
                          </div>
                          <div className="team-designation mb-0 text-uppercase theme-color">
                            <p className="mb-0 font-w-600">{data?.department}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default OverlayRevealHomeSpecialist;